// src/constants/vibeConstants.js

export const MOODS = [
    { value: 'happy', label: 'Happy', emoji: '😊', color: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400' },
    { value: 'excited', label: 'Excited', emoji: '🤩', color: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400' },
    { value: 'grateful', label: 'Grateful', emoji: '🙏', color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' },
    { value: 'proud', label: 'Proud', emoji: '💪', color: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400' },
    { value: 'motivated', label: 'Motivated', emoji: '🔥', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' },
    { value: 'neutral', label: 'Neutral', emoji: '😐', color: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-400' },
    { value: 'stressed', label: 'Stressed', emoji: '😰', color: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400' },
    { value: 'tired', label: 'Tired', emoji: '😴', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400' },
    { value: 'sad', label: 'Sad', emoji: '😢', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400' },
    { value: 'frustrated', label: 'Frustrated', emoji: '😤', color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' }
];

export const REACTIONS = [
    { type: 'like', emoji: '👍', label: 'Like', color: 'text-blue-600' },
    { type: 'love', emoji: '❤️', label: 'Love', color: 'text-red-600' },
    { type: 'celebrate', emoji: '🎉', label: 'Celebrate', color: 'text-yellow-600' },
    { type: 'support', emoji: '🤝', label: 'Support', color: 'text-green-600' },
    { type: 'funny', emoji: '😂', label: 'Funny', color: 'text-orange-600' },
    { type: 'insightful', emoji: '💡', label: 'Insightful', color: 'text-purple-600' },
    { type: 'clap', emoji: '👏', label: 'Clap', color: 'text-pink-600' }
];

export const RECOGNITION_TYPES = [
    { value: 'kudos', label: 'Kudos', emoji: '⭐', description: 'Give recognition for great work' },
    { value: 'shoutout', label: 'Shout Out', emoji: '📣', description: 'Public acknowledgment' },
    { value: 'thank_you', label: 'Thank You', emoji: '🙌', description: 'Express gratitude' },
    { value: 'well_done', label: 'Well Done', emoji: '👏', description: 'Congratulate achievement' }
];

export const POST_TYPES = [
    { value: 'vibe', label: 'Share Vibe', icon: '✨' },
    { value: 'recognition', label: 'Recognition', icon: '🏆' },
    { value: 'announcement', label: 'Announcement', icon: '📢' },
    { value: 'poll', label: 'Poll', icon: '📊' }
];

export const VISIBILITY_OPTIONS = [
    { value: 'company', label: 'Everyone in Company', icon: '🏢' },
    { value: 'team', label: 'My Team', icon: '👥' },
    { value: 'private', label: 'Only Me', icon: '🔒' }
];

export const FILTER_OPTIONS = [
    { value: 'company', label: 'Company Feed', icon: '🏢' },
    { value: 'my_vibes', label: 'My Vibes', icon: '👤' },
    { value: 'saved_vibes', label: 'Saved Vibes', icon: '🔖' }
];

export const SORT_OPTIONS = [
    { value: 'recent', label: 'Most Recent' },
    { value: 'popular', label: 'Most Popular' },
    { value: 'trending', label: 'Trending' }
];

export const getMoodData = (moodValue) => {
    return MOODS.find(m => m.value === moodValue) || MOODS[5]; // default to neutral
};

export const getReactionData = (reactionType) => {
    return REACTIONS.find(r => r.type === reactionType);
};

export const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return 'Just now';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
    if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)}d ago`;

    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};
